export default __webpack_public_path__ + "static/media/successPageV.e45945cd.svg";